/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import {
  Modal,
  Form,
  FormControl,
  Col,
  Button,
  FormGroup,
 } from 'react-bootstrap';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { isNumber } from 'lorautils/checkers/numbers';
import styles from './styles.scss';

const propTypes = {
  intl: intlShape.isRequired,
  radius: PropTypes.number.isRequired,
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

class CoverageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      radius: props.radius,
      showModal: props.showModal,
      error: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.roadtest');
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, radius } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (radius !== this.props.radius) {
      this.setState({ radius });
    }
  }

  handleOnChange(e) {
    const radius = _.trim(e.target.value);
    if (!isNumber(radius)) {
      this.setState({ error: true });
    } else {
      this.setState({ error: false });
    }
    this.setState({ radius });
  }

  handleSubmit() {
    const { radius, error } = this.state;
    if (error) {
      return;
    }
    const { onHide, onConfirm } = this.props;
    onConfirm(Number(radius));
    onHide();
  }

  render() {
    const { showModal, radius, error } = this.state;
    const { onHide } = this.props;

    return (
      <Modal
        show={showModal}
        bsClass="aisz-modal-light"
      >
        <Modal.Header closeButton onHide={onHide}>
          {this.intlMsg.msg('header.radius')}
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>
            <FormGroup>
              <Col md={3} className={styles.label}>
                {this.intlMsg.msg('radius.name')}
              </Col>
              <Col md={6}>
                <FormControl
                  value={radius}
                  type="number"
                  placeholder="radius"
                  bsClass="aisz-form-control-f"
                  onChange={this.handleOnChange}
                />
                <ControlTips
                  show={error}
                  message={this.intlMsg.msg('radius.invalid')}
                  azStyle="danger"
                  placement="top"
                />
              </Col>
              <Col md={1} className={styles.label}>km</Col>
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-success"
            onClick={() => this.handleSubmit()}
          >
            {this.intlMsg.msg('radius.confirm')}
          </Button>
          <Button
            bsStyle="aisz-default"
            onClick={onHide}
            className={styles.white}
          >
            {this.intlMsg.msg('radius.cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CoverageModal.propTypes = propTypes;

export default connect(null, null)(injectIntl(CoverageModal));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/coms/CoverageModal/index.jsx